export interface INavigationService {
    toggleSidenav(): void;
    goBack(): void;
    close(): void;
}

export class NavigationService {
    private _allowSideNavToChange = true;

    static $inject: string[] = ['$mdSidenav', '$state', '$window'];

    constructor(private _$mdSidenav: ng.material.ISidenavService,
        private _$state: ng.ui.IStateService,
        private _$window: ng.IWindowService) {
    }

    toggleSidenav(): void {
        if (this._allowSideNavToChange) {
            this._allowSideNavToChange = false;
            this._$mdSidenav('nav').toggle().then(() => {
                this._allowSideNavToChange = true;
            });
        }
    }

    close(): void {
        this._$window.history.back();
    }

    goBack(): void {
        if (this._$state.current.data && this._$state.current.data.navParent) {
            this._$state.go(this._$state.current.data.navParent);
        } else {
            this._$window.history.back();
        }
    }
}

angular.module('deliveryCreate.app')
    .service('NavigationService', NavigationService);


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/navigation/navigationService.ts
 **/